import { render, staticRenderFns } from "./FollowUpPost.vue?vue&type=template&id=7220ec6c&scoped=true&"
import script from "./FollowUpPost.vue?vue&type=script&lang=js&"
export * from "./FollowUpPost.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpPost.vue?vue&type=style&index=0&id=7220ec6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7220ec6c",
  null
  
)

export default component.exports